import Drawer from "../Drawer/Drawer";
import classNames from 'classnames';
import useHelpDrawerAnalytics from "./useHelpDrawerAnalytics";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
/**
 * For information about how and when to use this component,
 * [refer to its full documentation page](https://design.cms.gov/components/drawer/).
 */
export const HelpDrawer = props => {
  const {
    analytics,
    analyticsLabelOverride,
    onAnalyticsEvent,
    children,
    className,
    ...others
  } = props;
  const headingRef = useHelpDrawerAnalytics(props);
  return /*#__PURE__*/_jsx(Drawer, {
    className: classNames(className, 'ds-c-help-drawer'),
    headingRef: headingRef,
    ...others,
    children: children
  });
};
export default HelpDrawer;